function initTables() {
	const tables = document.getElementsByTagName('table');
	
	if (!tables.length)
		return;

	for (let table of tables) {
		setColspanToEmptyTd(table);

		$(table).colResizable({
			resizeMode: 'overflow',
		});
	}

	window.addEventListener("resize", () => {
		for (let table of tables) {
			$(table).colResizable({
				resizeMode: 'overflow',
			});
		}
	});

	function setColspanToEmptyTd(table) {
		const thCount = table.getElementsByTagName('th');
		if (!thCount.length)
			return;
		
		const emptyTd = table.querySelector('.td-empty');

		if (emptyTd) {
			emptyTd.setAttribute('colspan', thCount.length);
		}

	}

}